var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.09164C1.06572 3.76551 1.26234 2.93869 1.85051 2.35051C2.43869 1.76234 3.26551 1.56572 4.59164 1.5M13 5.09164C12.9343 3.76551 12.7376 2.93869 12.1495 2.35051C11.5613 1.76234 10.7345 1.56572 9.40834 1.5M9.40834 13.5C10.7345 13.4343 11.5613 13.2376 12.1495 12.6495C12.7376 12.0613 12.9343 11.2345 13 9.90834M4.59164 13.5C3.26551 13.4343 2.43869 13.2376 1.85051 12.6495C1.26234 12.0613 1.06572 11.2345 1 9.90834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57898 7.5H11.4211",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.8e606337f06cd3a25c6353df44b55546.svg";
export { ForwardRef as ReactComponent };